import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { Layout, LayoutSplashScreen } from "../_metronic/layout";
import { refreshTokens } from "../api/auth/index";
import { logError } from "../utils/logger";
import BasePage from "./BasePage";
import { AuthPage, Logout } from "./modules/Auth";
import { authActions } from "./modules/Auth/_redux/authActions";
import ErrorsPage from "./modules/Errors/ErrorsPage";

export function Routes() {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	const isLogged = useSelector(
		(store) => store.authentication?.loggedIn,
		shallowEqual
	);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	// Checking wether we have credentials in cookies before going to login
	useEffect(() => {
		function fetchMyCredentials() {
			setLoading(true);
			setTimeout(async () => {
				try {
					if (loggedUser) {
						const response = await refreshTokens(
							loggedUser?.refreshToken
						);
						if (response)
							dispatch(
								authActions.loginActionSuccess(response?.data)
							);
						setLoading(false);
					}
				} catch (error) {
					logError({
						error,
						customMessage: "Cannot get credentials, please login.",
					});
					// alertError({error})
					dispatch(authActions.logoutAction());
				}
				setLoading(false);
			}, 1000);
		}
		fetchMyCredentials();
	}, [dispatch]);

	useEffect(() => {
		if (isLogged) {
			const interval = setInterval(async () => {
				try {
					const response = await refreshTokens(
						loggedUser?.refreshToken
					);
					if (response) {
						let user = {
							...loggedUser,
							accessToken: response.data?.accessToken,
							refreshToken: response.data?.refreshToken,
						};
						dispatch(authActions.loginActionSuccess(user));
					}
				} catch (error) {
					logError({
						error,
						customMessage: "Cannot refresh tokens.",
					});
					// alertError({error})
					dispatch(authActions.logoutAction());
				}
			}, 2700000); //45 min
			return () => clearInterval(interval);
		}
	}, [dispatch, isLogged]);

	return loading ? (
		<LayoutSplashScreen />
	) : (
		<Switch>
			{!isLogged ? (
				/*Render auth page when user at `/auth` and not authorized.*/
				<Route>
					<AuthPage />
				</Route>
			) : (
				/*Otherwise redirect to root page (`/`)*/
				<Redirect from="/auth" to="/" />
			)}

			<Route path="/error" component={ErrorsPage} />
			<Route path="/logout" component={Logout} />

			{!isLogged ? (
				/*Redirect to `/auth` when user is not authorized*/
				<Redirect to="/auth/login" />
			) : (
				<Layout>
					<BasePage />
				</Layout>
			)}
		</Switch>
	);
}
